function ServiceJob({
  height = 35,
  primaryColor = 'rgb(232, 1, 1)',
  whiteColor = '#ffffff',
  onClick = null,
}) {
  const svgNS = 'http://www.w3.org/2000/svg';

  const originalWidth = 26;
  const originalHeight = 36;

  const width = (height * originalWidth) / originalHeight;

  const svg = document.createElementNS(svgNS, 'svg');
  svg.setAttribute('xmlns', svgNS);
  svg.setAttribute('width', width);
  svg.setAttribute('height', height);
  svg.setAttribute('viewBox', '0 0 26 36');
  svg.setAttribute('preserveAspectRatio', 'none');

  const createElement = (tag, attrs) => {
    const el = document.createElementNS(svgNS, tag);

    Object.entries(attrs).forEach(([k, v]) => {
      el.setAttribute(k, v);
    });

    return el;
  };

  // Outer circle
  svg.appendChild(
    createElement('ellipse', {
      cx: '13',
      cy: '13',
      rx: '13',
      ry: '13',
      fill: primaryColor,
      style: 'stroke-width:1; paint-order:fill;',
    }),
  );

  // Top pointer (triangle flipped vertically)
  svg.appendChild(
    createElement('path', {
      d: 'M 13 -35.992 L 25 -17.992 L 1 -17.992 L 13 -35.992 Z',
      transform: 'matrix(1, 0, 0, -1, 0, 0)',
      fill: primaryColor,
    }),
  );

  // Inner white triangle (roof shape)
  svg.appendChild(
    createElement('path', {
      d: 'M 13 4 L 21 12 L 5 12 L 13 4 Z',
      fill: whiteColor,
      style: 'stroke-width:7px; stroke-miterlimit:1; paint-order:fill;',
    }),
  );

  // White body rectangle
  svg.appendChild(
    createElement('rect', {
      x: '7',
      y: '10',
      width: '12',
      height: '10.001',
      fill: whiteColor,
      style: 'stroke-width:3px; paint-order:fill; stroke-linecap:round;',
    }),
  );

  // Inner red door
  svg.appendChild(
    createElement('rect', {
      x: '11',
      y: '14.963',
      width: '4',
      height: '6',
      fill: primaryColor,
      style: 'stroke-width:3px; fill-rule:evenodd;',
    }),
  );

  svg.addEventListener('click', e => {
    if (onClick) {
      onClick(e);
    }
  });

  return svg;
}

export default ServiceJob;
